import React, {PureComponent} from "react";
import $ from "jquery";

class CustomProgressBar extends PureComponent {
    render() {
        return (
            <div
                className={"progress-bar"}
                style={{
                    height: ($(window).width() <= 900 ? 17 : 27),
                }}
            >
                <Filler
                    percentage={this.props.percentage > 100 ? 100 : this.props.percentage}
                    color={this.props.color}
                    label={this.props.label}
                    realValue={this.props.realValue}
                />
            </div>
        );
    }
}

class Filler extends PureComponent {
    render() {
        return (
            <>
                <div
                    className={"filler"}
                    style={{
                        width: this.props.percentage + "%",
                        backgroundImage: "linear-gradient(to right, #dddddd 15%, " + this.props.color + " 100%)",
                    }}
                >
                </div>
                <div style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: 0,
                    lineHeight: ($(window).width() <= 900 ? 17 : 27) + "px",
                }}>
                    <span
                        className={"gaugeLegendStyle"}
                        style={{
                            marginLeft: 10,
                            float: "left",
                            color: "#8a1115",
                        }}
                    >{this.props.label}</span>
                    <span className={"gaugeBarValue"} style={{float: "right"}}>{this.props.realValue}</span>
                </div>
            </>
        );
    }
}

export default CustomProgressBar;